<template>
<div>

    <Sidebar v-if="appart"/>
    <Sidebar v-else title="Logis du Chateau" link="https://www.airbnb.fr/rooms/36438518" appartement="/logisduchateau"/>
    <list ref="museelist"> 
       



    </list>
    
</div>
    
</template>


<script>
import Sidebar from '../components/Sidebar'
import Map from '../components/Map'
import Vue from 'vue'
import {list, item} from '../components/CardMuseum.vue'
export default {
    name: 'Musee',
    components: {
        Sidebar,
        list,
        
        
    },
    beforeCreate: function() {
        document.body.className = 'musee';
    },computed: {

        appart() {
            if(this.$route.params.appartement == "chateau") return false;
            return true
        },
        

    },
    created()
    {
        const store = this.$firestore;
        store.collection('musee').get().then((querySnapshot) =>
        {
            querySnapshot.forEach((doc) => {

               var ItemClass = Vue.extend(item);
               var instance = new ItemClass({
                   propsData : {
                       title: doc.data().title,
                       text: doc.data().content,
                       url : doc.data().url_img
                   }
               });
               instance.$mount();
               this.$refs.museelist.$el.appendChild(instance.$el)
            })
            
        })
    }
    
}
</script>


<style scoped>            



.bg-pink {
    min-height: 100%;
    background-image: url('../assets/imgs/tissu_pink.png')!important;
    background-size: 40%;
    background-repeat: repeat;
}

                                                                                                                         



</style>